import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { loadState, reset } from "../localStorage";
import {
  SignupStepReducer,
  SignupRegisterReducer,
  SignupSelectedFeature,
  SignupOTP,
  ProceedToDashboard,
  ResetSignupOTP,
} from "./signup-reducer";
import AppIconsReducers from "AppIconsReducers";
import ContentFeaturesReducer from "ContentFeaturesReducer";
import {
  LOGIN,
  SELECT_APP_ICON,
  REGISTER,
  SELECTED_CONTENT_FEATURE,
  APP_API_KEY,
  EDIT_CONTENT_ICON_NAME,
  TO_CHANGE_EMAIL,
  UPDATE_UNSAVED_STATUS,
} from "Constants";
import {
  ACTION_LOGOUT,
  CREATE_EVENT_INSIDE_DASHBORAD,
  SESSION_TOKEN,
  EVENT,
  USER_ID,
  USER_NAME,
  USER_PICTURE,
  ADMIN_USER_ID,
  USER_EMAIL,
  VERIFY_OTP_LOGIN,
  LOGIN_PROCESS_CALLBACK,
  ALL_EVENTS,
  ALL_ADMIN_EVENTS,
  OPEN_EVENT_CHOOSER_MODAL,
  INITIATE_CREATE_EVENT,
  IS_SUPERADMIN,
  ADMIN_EVENT_LIMITS,
  ADMIN_GROUP_NUMBER,
  ADMIN_CLIENT_NUMBER,
  ADMIN_EVENTS_CREATED,
  OPEN_EVENT_CLONE_MODAL,
  CLONE_EVENT_STATUS,
  DEVICE_SIZE,
  CLIENTINVOICE_FORPAYMENT,
  CLIENT_EXPIRYAND_USERLIMIT,
  ADMIN_EVENT_VALIDUPTO,
  ADMIN_USERLIMIT,
  RESET_REDUX_STORE_ADMIN_NO_EVENT,
} from "Actions";
import {
  allSpeakersReducers,
  SpeakersReducers,
  openSpeakerPopup,
  loadEditSpeakerData,
  speakerImageReducer,
  speakerfilesList,
  speakerfilesChanged,
  importSpeakerModal,
  speakersCount,
} from "SpeakersReducers";
import {
  SchedulesDataReducers,
  SessionColorsReducer,
  SchedulesTrackReducer,
  SelectedScheduleDateReducer,
  TrackPopupReducer,
  SessionPopupReducer,
  sessionPrivateUsersModal,
  sessionfilesList,
  sendPushTimes,
  checkinType,
  scheduleImportModal,
  singleSessionAssociatedUsers,
  singleSessionRSVPUsers,
  sessionAssociatedSpeakers,
  sessionScreenZoom,
  bulkEditModalControlReducer,
} from "ScheduleReducers";
import { loadingBarReducer } from "react-redux-loading-bar";
import {
  AllSponsorsReducers,
  SponsorsReducers,
  openSponsorPopup,
  loadEditSponsorData,
  SponsorCategoryReducers,
  SponsorCategoryEditReducers,
  sponsorImageReducer,
  sponsorFilesList,
  sponsorFilesChanged,
  importSponsorModal,
  sponsorBannerReducer,
  sponsorWorkingDynamicForm,
  sponsorsCount,
} from "SponsorsReducers";
import {
  AllExhibitorsReducers,
  ExhibitorsReducers,
  ProductCategories,
  ProductIndustries,
  ProductSubCategories,
  openExhibitorPopup,
  loadEditExhibitorData,
  exhibitorImageReducer,
  exhibitorFilesList,
  exhibitorFilesChanged,
  importExhibitorModal,
  exhibitorBannerReducer,
  exhibitorWorkingDynamicForm,
  exhibitorsCount,
} from "ExhibitorsReducers";
import { WebviewReducers, loadEditWebviewData } from "WebviewReducers";
import { AboutReducers, loadEditAboutData } from "AboutReducers";
import { ErrorBarReducer } from "ReduxErrorBar";
import {
  locationMapReducers,
  ShowLocationMapModal,
  InitialLocationMap,
} from "LocationMapReducer";
import {
  selectedFeaturesReducer,
  fetchScheduleDates,
  updateScheduleDates,
  DatePropsReducer,
  totalAppModules,
  actionAppModules,
  contentDashboard,
  editSeoCode,
  contentDisplayItems,
  appMenuReducer,
  appBtmMenuFixed,
  fixedFeatures,
} from "GeneralTabReducers";
import {
  eventReducers,
  InterestModalReducer,
  InterestsReducers,
  EditInterestReducers,
  eventSettingsReducers,
  loggedinuserData,
} from "MessageReducers";
import {
  SocialReducers,
  loadEditSocialData,
  openSocialPopup,
  isOpenInstaLoader,
} from "SocialReducers";
import {
  fetchNews,
  fetchNewsItem,
  openNewsPopup,
  newsImageReducer,
} from "NewsReducers";
import {
  fetchGallery,
  imageReadyToAddGallery,
  thumbnailImage,
  galleryModal,
} from "GalleryReducers";
import {
  advertisementsList,
  advtAddModal,
  advtBannerOptions,
  advtEditData,
} from "ReducersAdvertisement";
import { surveyList, surveyResponseData } from "SurveyReducers";
import {
  communityList,
  addCommunityModal,
  editCommunity,
  requestedCommunityMemberList,
} from "ReducersCommunity";

/**** Content Event Guide Import ****/
import {
  EventGuideList,
  OpenEventGuideModal,
  LoadEditeventguidesData,
  GetMaxDisplayorderEventGuide,
  eventguidefilesList,
  eventguidefilesChanged,
  CategoryList,
} from "EventguideReducers";

/**** Gamification Import ****/
import GamificationMenus from "GamificationMenus";
import {
  ManagechallengesMenu,
  ManagechallengesSelectedTab,
  ManageChallengesList,
  LoadEditchallengesData,
  OpenChallengesPopup,
  GetMaxDisplayorder,
  getStaticTemplteHtml,
} from "ManagechallengesReducers"; // Gamification -> Manage Challenges
import {
  LeaderboardUserList,
  extraPointsModalReducer,
  allGameChallengesReducer,
  gamificationLogList,
} from "LeaderboardReducers"; // Gamification -> Manage Challenges
import { RewardData } from "RewardssettingsReducers"; // Gamification -> Rewards Settings

import AnalyticsMenus from "AnalyticsMenus";
import {
  DashBoardMenu,
  DashboardSelectedItem,
  DashboardMostsearchKeysTablelist,
  DashboardEngagementbarChart,
} from "DashBoardReducers";
import { DashboardTotalDevices } from "DashboardDeviceReducer";
import { DashboardTotalNetworking } from "DashboardNetworkingReducer";
import { DashboardTotalSessions } from "DashboardSessionReducer";

import { DashboardTotalAttendees } from "DashboardAttendeesReducer"; // Analytics -> Dashboard -> reducers [Attendees]
import { DashboardTotalAttenadoprate } from "DashboardAttenadoprateReducer"; // Analytics -> Dashboard -> reducers [Attendees Adoption rate]
import { DashboardTotalAttedengaRate } from "DashboardAttedengarateReducer"; // Analytics -> Dashboard -> reducers [Attendees Engagement rate]
import { DashboardTotalInteractionRate } from "DashboardInteractionReducer"; // Analytics -> Dashboard -> reducers [Interaction rate]
import { DashboardTotalMessagessCount } from "DashboardMessagessReducer"; // Analytics -> Dashboard -> reducers [Messages count]

import {
  SocialFeedMenu,
  SocialfeedSelectedItem,
  SocialfeedTousersEngagetablelist,
  SocialfeedPostypePaichartData,
} from "SocialfeedReducers"; // Analytics -> Social feed
import { SocialfeedTotalPost } from "SocialfeedPostReducer"; // Analytics -> Social feed -> reducers [POSTS]
import { SocialfeedTotalReaction } from "SocialfeedReactionReducer"; // Analytics -> Social feed -> reducers [REACTIONS]
import { SocialfeedTotalComment } from "SocialfeedCommentReducer"; // Analytics -> Social feed -> reducers [COMMENT]
import { SocialfeedTotalMedia } from "SocialfeedMediaReducer"; // Analytics -> Social feed -> reducers [MEDIA]
import { SocialfeedTotalPoll } from "SocialfeedPollReducer"; // Analytics -> Social feed -> reducers [POLL]

import {
  AttendeesMessagingMenu,
  AttendeesmessagingSelectedItem,
} from "AttendeesmessagingReducers"; // Analytics -> Attendees Messaging
import { AttendeesmessagingTotalSentmsg } from "AttendeesmessagingSentmsgReducer"; // Analytics -> Attendees -> reducers [Attendee Sent Message]
import {
  AttendeesmessagingTotalCommunication,
  AttendeesmessagingEngagementChart,
} from "AttendeesmessagingCommunicationReducer"; // Analytics -> Attendees -> reducers [Attendee Communication]
import { AttendeesmessagingTotalRecemsg } from "AttendeesmessagingRecemsgReducer"; // Analytics -> Attendees -> reducers [Attendee Received Message]
import { AttendeesmessagingTotalMsgthread } from "AttendeesmessagingMsgthreadReducer"; // Analytics -> Attendees -> reducers [Attendee Message Threads]

import {
  SpeakerAnalyticMenu,
  SpeakerSelectedItem,
  SpeakerTopspkrTablelist,
  SpeakerMostsearkeysTablelist,
  SpeakerEngagementbarChart,
} from "SpeakeranalyticReducers"; // Analytics -> Speaker
import { SpeakerAnalyticTotalNoofspkr } from "SpeakeranalyticNoofspkrReducer"; // Analytics -> Speaker -> reducers [Number of speakers]
import { SpeakerAnalyticTotalSpkrlistview } from "SpeakeranalyticSpkrlistviewReducer"; // Analytics -> Speaker -> reducers [Speaker's list views]
import { SpeakerAnalyticTotalSpkrprofview } from "SpeakeranalyticSpkrprofviewReducer"; // Analytics -> Speaker -> reducers [Speaker's profile views]
import { SpeakerAnalyticTotalSpkrfavo } from "SpeakeranalyticSpkrfavoReducer"; // Analytics -> Speaker -> reducers [Speaker favourites]

import {
  SessionAnalyticMenu,
  SessionSelectedItem,
  SessionTosessTablelist,
  SessionQnqinsightsTablelist,
  SessionMostsearkeysTablelist,
  EventSessionList,
  SessionScannedList,
  SessionRSVPUsersList,
} from "SessionanalyticReducers"; // Analytics -> Session
import { SessionAnalyticTotalSesslist } from "SessionanalyticSessviewReducer"; // // Analytics -> Session -> reducers [Session views]
import { SessionAnalyticTotalSessfavo } from "SessionanalyticSessfavoReducer"; // // Analytics -> Session -> reducers [Session favorites]
import { SpeakerTotalExhisearch } from "SpeakeranalyticSpkrsearchReducer"; // // Analytics -> Session -> reducers [Session searches]
import { SessionAnalyticTotalSessListCnt } from "SessionanalyticSesslistReducer"; // // Analytics -> Session -> reducers [Session List]

import {
  SponsorInsightMenu,
  SponsorsinsightSelectedItem,
  SponsorsinsightMostsearkeysTablelist,
  SponsorsinsightTopsponTablelist,
  SponsorsinsightEngagementbarChart,
} from "SponsorinsightReducers"; // Analytics -> Sponsors Insights
import { SponsorsinsightTotalNoofspon } from "SponsorinsightNoofsponReducer"; // Analytics -> Sponsors Insights -> reducers [Number of sponsors]
import { SponsorsinsightTotalSponlistview } from "SponsorinsightSponlistviewReducer"; // Analytics -> Sponsors Insights -> reducers [Sponsor's list views]
import { SponsorsinsightTotalSponprofview } from "SponsorinsightSponprofviewReducer"; // Analytics -> Sponsors Insights -> reducers [Sponsor's profile views]
import { SponsorsinsightTotalExhisearch } from "SponsorinsightSponsearchReducer"; // Analytics -> Sponsors Insights -> reducers [Sponsor searches]
import { SponsorsinsightTotalSponfavo } from "SponsorinsightSponfavoReducer"; // Analytics -> Sponsors Insights -> reducers [Sponsor favourites]

import {
  ExhibitorInsightMenu,
  ExhibitorsinsightSelectedItem,
  ExhibitorsinsightMostsearkeysTablelist,
  ExhibitorsinsightTopexhiTablelist,
  ExhibitorsinsightToptagsexhiTablelist,
  ExhibitorsinsightTopcountriesexhiTablelist,
  ExhibitorsinsightEngagementbarChart,
} from "ExhibitorinsightReducers"; // Analytics -> Exhibitors insights
import { ExhibitorsinsightTotalNoofexhi } from "ExhibitorinsightNoofexhiReducer"; // Analytics -> Exhibitors insights -> reducers [Number of Exhibitors]
import { ExhibitorsinsightTotalExhilistview } from "ExhibitorinsightExhilistviewReducer"; // Analytics -> Exhibitors insights -> reducers [Exhibitors's list views]
import { ExhibitorsinsightTotalExhiprofview } from "ExhibitorinsightExhiprofviewReducer"; // Analytics -> Exhibitors insights -> reducers [Exhibitors's profile views]
import { ExhibitorsinsightTotalExhifavo } from "ExhibitorinsightExhifavoReducer"; // Analytics -> Exhibitors insights -> reducers [Exhibitor favourites]
import { ExhibitorsinsightTotalExhisearch } from "ExhibitorinsightExhisearchReducer"; // Analytics -> Exhibitors insights -> reducers [Exhibitor searches]

import {
  AttendeesNetworkMenu,
  AttendeesnetworkSelectedItem,
  AttendeesnetworkPopuattenTablelist,
  AttendeesnetworkMstactvattenTablelist,
  AttendeesnetworkMostsearkeysTablelist,
  AttendeesnetworkEngagementbarChart,
} from "AttendeesnetworkReducers"; // Analytics -> Attendees Network
import { AttendeesnetworkTotalMsgsent } from "AttendeesnetworkMsgsentReducer"; // Analytics -> Attendees Network -> reducers [Message Sent]
import { AttendeesnetworkTotalScans } from "AttendeesnetworkScansReducer"; // Analytics -> Attendees Network -> reducers [Scans]
import { AttendeesnetworkTotalExhiprofview } from "AttendeesnetworkProfviewReducer"; // Analytics -> Attendees Network -> reducers [Attendee's profile views]
import { AttendeesnetworkTotalSearch } from "AttendeesnetworkAttesearReducer"; // Analytics -> Attendees Network -> reducers [Attendees searches]
import { AttendeesNetworktotalfavo } from "AttendeesnetworkAttefavoReducer"; // Analytics -> Attendees Network -> reducers [Attendee favourites]

import { AnalyticscommonDatePropsReducer } from "AnalyticscommonReducers";

import {
  advertisementviewAnalyticsdatalist,
  advertisementclickAnalyticsdatalist,
  advertisementAnalyticscounts,
} from "AdvertisementinsightReducers"; //Analytics Advertisement Reducer

/**** Advertisement analytics ****/
// import { advAnalyticsMenu } from "ReducersAdvertisement";

/*** Support Chat  ***/
import {
  Chatthread,
  ChatthreadDetails,
  userDetailsWithEmail,
} from "SupportChatReducer";

import {
  AddEditBoothReducer,
  ShowBoothEditorReducer,
  ShowAddBoothInfoReducer,
  FetchInteractiveMapsReducer,
  FetchLinkResourceReducer,
  UpdatedBoothReducer,
  DeleteBoothLinkReducer,
  OpenIMapReducer,
  AddMapNameReducer,
  OpeniMapModalReducer,
  ChangeMapReducer,
  UploadImapProgressReducer,
  ImapImageUploadFailedReducer,
  ImapImageUploadedReducer,
  ImapImageUploadReducer,
  EditBoothDataReducer,
  AddBoothDataReducer,
  interactivemaplocationsession,
} from "InteractiveMapReducer";

import {
  DashboardUserList,
  DashboardTotalUsers,
  UserOrderByDateCreated,
  ShowDashboardUserModal,
  ShowDashboardUserExportModal,
  DashboardUser,
  ShowImportUserModal,
  userEventDetails,
  bulkUserUplodingLeft,
  DashboardUserCategoryWise,
  EventbriteKeys,
  ShowEventPolicyTypeModal,
  DownloadUser,
  userRestPasswordModal,
  ShowDashboardUserCategoryModal,
  UserCategoryList,
  addEditUserCategory,
  DashboardTotalNoOfUsersHits,
  totalNumberOfUsers,
  appuserGroupManageModal,
  appUserListGroupManage,
  passcodeEmail,
  TotalUsers,
  eventDefautUserCheckoutForm,
  appuserCounts,
  usernotLoginCount,
  viewAnalyticsData,
  userScanData,
  totalUsernotLoginCount,
} from "DashboardUserReducer";
import {
  DashboardNotificationList,
  DashboardScheduledNotificationList,
  ShowChooseUserModal,
  DashboardUserListWithoutAdmin,
  DashboardNotificationModal,
  DashboardNotificationViewModal,
} from "DashboardOutreachReducer";
import BrandingMenus from "BrandingMenus";
import {
  brandingReducers,
  brandingColorReducers,
  brandingThemeColorsReducers,
  brandingLocalIconImageReducer,
  brandingLocalCoverImageReducer,
  brandingLocalWebIconImageReducer,
  brandingLocalWebCoverImageReducer,
  brandingWebColorReducers,
  brandingWebThemeColorsReducers,
  isUpdatedSideBottomAppMenu,
  EditAppBottomMenuReducer,
  createdMenu,
  splashScreenData,
} from "BrandingReducers";

import {
  ShowCheckoutModalReducer,
  UpdateCheckoutDetailsReducer,
  GlobalCountReducer,
  ContactUsModalReducer,
} from "CheckoutReducers";

import { speakerFileList } from "ReducersSpeakerFile";

import { sponsorFileList } from "ReducersSponsorFile";

import { exhibitorFileList } from "ReducersExhibitorFile";

import {
  UploadContentFileUploadedReducer,
  UploadContentFileFailedReducer,
  UploadContentFileProgressReducer,
} from "ContentFileUploadReducer";

/* Badge Design */
import {
  isBadgeDesignModalOpen,
  isGenerateBadgeModalOpen,
  dashboardAllBadgeList,
  dashboardBadgeList,
  templateJson, //json object
  selectedElement,
  dataInEditMode, //Data for edit badge
  DashboardBadgeAllUserList, // All users list
  DashboardBadgeUserList, // User list
  userDetails,
  isPrintPreviewModalOpen, //Print preview Modal
  imageElementModal,
} from "BadgeDesignReducer";

import {
  UPDATE_PROCESSING_STATUS,
  SELECT_REVEAL_ICON,
  COUNTRY_LIST,
  SUPPORTCHAT_UNREADCOUNT,
} from "DashboardMenuAction";
import TemplatesMenus from "TemplatesMenus";
import {
  TEMPLATES_CONTENT,
  EVENT_SELECTED_TEMPLATE,
  GET_EVENTCODE,
  WEBSITE_CONTACT_RESPONSES,
} from "TemplatesAction";
import {
  FEATURES_MODAL,
  CONTENT_ADD_REMOVE_MODAL,
  SESSION_WEEKDAYS,
  SESSION_DEFAULT_TRACK,
  ACTIVE_DATE_ALL_SESSION,
  ALL_ADDITIONAL_SESSIONS,
} from "ContentActions";
import { OPEN_MEMBERSHIP_MODAL } from "ActionsSponsors";

import TicketReducers from "TicketReducers";
import TicketCurrency from "TicketCurrency";

import {
  TicketList,
  allTicketList,
  siglrCategoryTicketList,
  allCouponList,
  CouponList,
  EditCoupon,
  EditTicket,
  SettingData,
  OrderList,
  StripeAccountData,
  showTicketModal,
  ticketDashboard,
  showTicketUrlModal,
  showTicketOrderUrlModal,
  showOrderTicketModal,
  showDefaultTermsModal,
  stripeCurrencyDetailsList,
  WizardStep,
  ShowSalesReportExportModal,
  refundModalShow,
  paymentGatewayModal,
  clientCardInfoModal,
  ticketSendList,
  ticketSesionModal,
  ticketSortbyModal,
} from "TicketActionReducers";
import {
  formBuilderModal,
  formList,
  formName,
  formBuildeList,
  totalFormBuildeList,
  formChanged,
} from "FormBuilderReducer";

import PollMenus from "PollMenus";
import {
  pollList,
  selectPollListType,
  ShowPollExportModal,
  broadcastLivePolls,
} from "PollReducers";
import {
  scheduleSessions,
  selectedSession,
  livePublishedQAList,
  liveUnpublishedQAList,
  selectPublishedType,
  liveQAReplies,
  broadcastLiveQA,
  allPublishesSessionwiseLiveQA,
  ShowLiveQAExportModal,
  singleSessionRatings,
  allSessionRatings,
  allSessionId,
  singleSessionCheckouForm,
} from "LiveQAReducers";

import SettingMenus from "SettingMenus";

import {
  templateReducers,
  appstoreDetails,
  appstoreLocalLogoReducer,
  appstoreOtherImagesReducer,
  emailLogReducers,
  emailLogContentReducers,
  activeUsrsDetails,
  languageAddModalReducer,
  eventLanguages,
  languageCsvImportModalReducer,
  integrationModalReducer,
  allEmailLog,
} from "SettingReducers";
import AccountSettingMenus from "AccountSettingMenus";
import {
  clientdataforbilling,
  alleventclientData,
  client_historydata,
  total_accountusageCount,
  usagehistoryDatalist,
  reportPlatforms,
  adminissueListopen,
  adminissueListclose,
  alleventsunderClient,
  eventBasedData,
  eventsunderClient,
  singleReportdata,
  allcountryList,
} from "AccountSettingsReducer";
import ProposalReducer from "ProposalReducer";
import {
  ProposalStep,
  checkProposalForm,
  proposalReviewerStatus,
  proposalReviewCriteriaStatus,
  appUserreviewerList,
  proposalFormList,
  reviewerList,
  responseList,
  proposalList,
  showProposalUrlModal,
  editProposalModal,
  addReviewerModal,
  showChangeReviewer,
  showProposalResponse,
  proposalRanking,
  showProposalTicketModal,
  showManageProposalModal,
  updateProposal,
  showChangePasswordReviewer,
  proposalConfirmModal,
  proposalAttendeeList,
  unreviewedproposalList,
  reviewedproposalList,
  shortlistedproposalList,
  rejectedproposalList,
  showproposalLoader,
  ratingStore,
  allresponseProposal,
  updatedProposalLoader,
  filterbyProposal,
  sortbyFilter,
} from "ProposalActionReducers";

import CourseMenus from "CourseMenus";
import {
  courseWizardStep,
  courseWizardAllSteps,
  allCourseList,
  allCourseName,
  allUnpublishedCourseList,
  courseList,
  quizList,
  courseLessonModal,
  lessonTextAttachment,
  lessonDocumentAttachment,
  lessonVideoAttachment,
  lessonAudioAttachment,
  lessonLinkAttachment,
  currentChapterOpen,
  tempChapterRanking,
  tempLessonRanking,
  editLessonData,
  chapterModal,
  courseModal,
} from "CourseReducers";

import {
  TemplatesWizardStep,
  TemplatesWizardData,
  connectDomainModal,
  connectDomainData,
  optionStateInstallURL,
  templateThemeData,
  optionStatePublish,
  confirmModal,
  selectedPlan,
  optionStateTheme,
  websiteModule,
  siteDetails,
  optionStateDomains,
  optionStateUpgrade,
  templateModulepath,
  redeploy,
  initialCheckAtTheme,
  templateImagepath,
  websitePages,
  titleUrl,
  headerFooter,
} from "../../src/components/dashboard/components/templates/reducers";

var LoginReducer = (state = true, action) => {
  // need to change it to false
  var state = loadState();

  if (state == undefined) {
    state = {
      isLoggedIn: false,
    };
  }

  if (action.type === LOGIN) {
    state.isLoggedIn = action.payload;
  }

  if (action.type === ACTION_LOGOUT) {
    state.isLoggedIn = action.payload;
  }

  return state.isLoggedIn;
};

var RegisterReducer = (state = true, action) => {
  // need to change it to false
  switch (action.type) {
    case REGISTER:
      return action.payload;
    default:
      return state;
  }
};

var TokensReducer = (state = {}, action) => {
  var state = loadState();

  if (state == undefined || state.session == undefined) {
    state = {
      session: {
        apiKey: "",
        sessionToken: "",
        eventid: "",
        eventname: "",
        emailid: "",
        userid: "",
        userpic: "",
        onesignalid: "",
        onesignalkey: "",
      },
    };
  }

  if (action.type === SESSION_TOKEN) {
    if (action.payload.session_token) {
      state.session.apiKey = APP_API_KEY;
      state.session.sessionToken = action.payload.session_token;
      state.session.emailid = action.payload.email;
    }
  }

  if (action.type === EVENT) {
    state.session.eventid = action.payload.eventid;
    state.session.eventname = action.payload.eventname;
    state.session.userid = action.payload.userid;
    state.session.userpic = action.payload.userpic;
    state.session.onesignalid = action.payload.onesignalid;
    state.session.onesignalkey = action.payload.onesignalkey;
  }

  if (action.type === ACTION_LOGOUT) {
    // state.session.sessionToken = "";
    // state.session.apiKey = "";
    // state.session.eventid = "";
    // state.session.eventname = "";
    // state.session.emailid = "";
    // state.session.userid = "";
    // state.session.userpic = "";
    // state.session.onesignalid = "";
    // state.session.onesignalkey = "";
    state.session = {};
    reset();
  }

  return state.session;
};

var UserReducer = (state = {}, action) => {
  var state = loadState();
  if (state === undefined || state.user == undefined) {
    state = {
      user: {
        userid: "",
        adminuserid: "",
        username: "",
        userpic: "",
        email: "",
        totalAdminEvents: "0",
        isSuperAdmin: false,
        groupNumber: "",
        clientid: "",
        totalCreatedEvents: "0",
        allowedEvent: "0",
        validupto: "",
        userlimit: "0",
      },
    };
  }

  // DF user id
  if (action.type === USER_ID) {
    state.user.userid = action.payload;
  }
  // primary key of adminuser table of eventify DB
  if (action.type === ADMIN_USER_ID) {
    state.user.adminuserid = action.payload;
  }
  if (action.type === USER_NAME) {
    state.user.username = action.payload;
  }
  if (action.type === USER_PICTURE) {
    state.user.userpic = action.payload;
  }
  if (action.type === USER_EMAIL) {
    state.user.email = action.payload;
  }
  if (action.type === ALL_ADMIN_EVENTS) {
    state.user.totalAdminEvents = action.payload;
  }
  if (action.type === IS_SUPERADMIN) {
    state.user.isSuperAdmin = action.payload;
  }
  if (action.type === ADMIN_GROUP_NUMBER) {
    state.user.groupNumber = action.payload;
  }
  if (action.type === ADMIN_CLIENT_NUMBER) {
    state.user.clientid = action.payload;
  }
  if (action.type === ADMIN_EVENTS_CREATED) {
    state.user.totalCreatedEvents = action.payload;
  }
  if (action.type === ADMIN_EVENT_LIMITS) {
    state.user.allowedEvent = action.payload;
  }
  if (action.type === ADMIN_EVENT_VALIDUPTO) {
    state.user.validupto = action.payload;
  }
  if (action.type === ADMIN_USERLIMIT) {
    state.user.userlimit = action.payload;
  }

  if (action.type === ACTION_LOGOUT) {
    // state.user.userid = "";
    // state.user.adminuserid = "";
    // state.user.username = "";
    // state.user.userpic = "";
    // state.user.email = "";
    // state.user.totalAdminEvents = "0";
    // state.isSuperAdmin = false;
    // state.user.groupNumber = "";
    // state.user.clientid = "";
    // state.user.totalCreatedEvents = "0";
    // state.user.allowedEvent = "0";
    // state.user.validupto = "";
    // state.user.userlimit = "0";
    state.user = {};
  }

  return state.user;
};

var SelectAppIconReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECT_APP_ICON:
      return action.payload;
    default:
      return state;
  }
};

var SelectRevealIconReducer = (
  state = { title: "", iconName: "separatortop", description: "" },
  action
) => {
  switch (action.type) {
    case SELECT_REVEAL_ICON:
      return action.payload;
    default:
      return state;
  }
};

var CountryList = (state = {}, action) => {
  switch (action.type) {
    case COUNTRY_LIST:
      return action.payload;
    default:
      return state;
  }
};

var UpdateUnsavedChangesReducer = (state = false, action) => {
  switch (action.type) {
    case UPDATE_UNSAVED_STATUS:
      return action.payload;
    default:
      return state;
  }
};

var EditContentIconNameReducer = (state = false, action) => {
  switch (action.type) {
    case EDIT_CONTENT_ICON_NAME:
      return action.payload;
    default:
      return state;
  }
};

var TemplatesReducer = (state = [], action) => {
  switch (action.type) {
    case TEMPLATES_CONTENT:
      return action.payload.resource;
    default:
      return state;
  }
};

var EventcodeReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_EVENTCODE:
      return action.payload.eventcode;
    default:
      return state;
  }
};

var eventTemplatesReducer = (state = [], action) => {
  switch (action.type) {
    case EVENT_SELECTED_TEMPLATE:
      return action.payload.resource;
    default:
      return state;
  }
};

var websiteContactReducer = (state = [], action) => {
  switch (action.type) {
    case WEBSITE_CONTACT_RESPONSES:
      return action.payload.resource;
    default:
      return state;
  }
};

var SignupChangeEmail = (state = false, action) => {
  if (action.type === TO_CHANGE_EMAIL) {
    return action.payload;
  }

  return state;
};

var createEventFromDashboard = (state = false, action) => {
  if (action.type === "CREATE_EVENT_INSIDE_DASHBORAD") {
    return action.payload;
  }
  return state;
};

var ContentFeatureReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECTED_CONTENT_FEATURE:
      return action.payload;
    default:
      return state;
  }
};

var ProceedToLogin = (state = false, action) => {
  if (action.type === "ProceedToLogin") {
    return action.payload;
  }
  if (action.type === ACTION_LOGOUT) {
    return false;
  }
  return state;
};

var OpenLoginOTPModal = (state = false, action) => {
  if (action.type === VERIFY_OTP_LOGIN) {
    return action.payload;
  }
  return state;
};

var loginProcessCallback = (state = null, action) => {
  if (action.type === LOGIN_PROCESS_CALLBACK) {
    return action.payload;
  }
  return state;
};

var FromLogin = (state = false, action) => {
  if (action.type === "login_otp_verify") {
    return action.payload;
  }
  return state;
};

var ProcessingReducer = (state = false, action) => {
  if (action.type === UPDATE_PROCESSING_STATUS) {
    return action.payload;
  }
  return state;
};

var ShowFeaturesModalReducer = (state = false, action) => {
  if (action.type === FEATURES_MODAL) {
    return action.payload;
  }
  return state;
};

var contentAddRemoveModal = (state = {}, action) => {
  if (action.type === CONTENT_ADD_REMOVE_MODAL) {
    return action.payload;
  }
  return state;
};

var sessionWeekdays = (state = [], action) => {
  if (action.type === SESSION_WEEKDAYS) {
    return action.payload;
  }
  return state;
};
var sessionDefaultTrack = (state = [], action) => {
  if (action.type === SESSION_DEFAULT_TRACK) {
    return action.payload;
  }
  return state;
};
var activeDateAllSessions = (state = {}, action) => {
  if (action.type === ACTIVE_DATE_ALL_SESSION) {
    return action.payload;
  }
  return state;
};

var allAdditionalSessions = (state = {}, action) => {
  if (action.type === ALL_ADDITIONAL_SESSIONS) {
    return action.payload;
  }
  return state;
};

var ShowMembershipModalReducer = (state = false, action) => {
  if (action.type === OPEN_MEMBERSHIP_MODAL) {
    return action.payload;
  }
  return state;
};

var AllEventsReducer = (state = {}, action) => {
  if (action.type === ALL_EVENTS) {
    return action.payload;
  }
  return state;
};

var OpenEventChooserReducer = (state = false, action) => {
  if (action.type === OPEN_EVENT_CHOOSER_MODAL) {
    return action.payload;
  }
  return state;
};

var OpenEventCloneReducer = (state = false, action) => {
  if (action.type === OPEN_EVENT_CLONE_MODAL) {
    return action.payload;
  }
  return state;
};

var CloneEventStatusReducer = (state = false, action) => {
  if (action.type === CLONE_EVENT_STATUS) {
    return action.payload;
  }
  return state;
};

var deviceSize = (state = {}, action) => {
  if (action.type === DEVICE_SIZE) {
    return action.payload;
  }
  return state;
};
// Client Payment
var clientinvoiceforpayment = (state = [], action) => {
  if (action.type === CLIENTINVOICE_FORPAYMENT) {
    return action.payload;
  }
  return state;
};
var clientuserlimitandexpiry = (state = [], action) => {
  if (action.type === CLIENT_EXPIRYAND_USERLIMIT) {
    return action.payload;
  }
  return state;
};

var InitiateCreateEventReducer = (state = false, action) => {
  if (action.type === INITIATE_CREATE_EVENT) {
    return action.payload;
  }
  return state;
};

// Local reducers for Support Chat thread
var unreadcount = (state = {}, action) => {
  switch (action.type) {
    case SUPPORTCHAT_UNREADCOUNT:
      return action.data;
    default:
      return state;
  }
};

var appReducer = combineReducers({
  isLoggedIn: LoginReducer,
  // isLoggedIn:RegisterReducer,
  createEventFromDashboard: createEventFromDashboard,
  appicons: AppIconsReducers,
  selectedMenu: SelectAppIconReducer,
  selectedRevealMenu: SelectRevealIconReducer,
  CountryList: CountryList,
  unsavedChanges: UpdateUnsavedChangesReducer,
  session: TokensReducer,
  selectedContentFeature: ContentFeatureReducer,
  form: formReducer,
  loadingBar: loadingBarReducer,
  errorBar: ErrorBarReducer,

  allSpeakers: allSpeakersReducers,
  speakers: SpeakersReducers,
  speakerModal: openSpeakerPopup,
  speaker: loadEditSpeakerData,
  speakerImage: speakerImageReducer,
  speakerfilesList: speakerfilesList,
  speakerfilesChanged: speakerfilesChanged,
  importSpeakerModal: importSpeakerModal,
  speakersCount: speakersCount,

  scheduleData: SchedulesDataReducers,
  tracks: SchedulesTrackReducer,
  selectedScheduleDate: SelectedScheduleDateReducer,
  trackModal: TrackPopupReducer,
  sessionModal: SessionPopupReducer,
  sessionPrivateUsersModal: sessionPrivateUsersModal,
  sessionfilesList: sessionfilesList,
  scheduleImportModal,
  singleSessionAssociatedUsers,
  singleSessionRSVPUsers,
  sessionAssociatedSpeakers,
  sessionScreenZoom,
  bulkEditModalControlReducer,

  allExhibitors: AllExhibitorsReducers,
  exhibitors: ExhibitorsReducers,
  exhibitorProductCategories: ProductCategories,
  exhibitorProductIndustries: ProductIndustries,
  exhibitorProductSubCategories: ProductSubCategories,
  exhibitor: loadEditExhibitorData,
  exhibitorImage: exhibitorImageReducer,
  exhibitorBanner: exhibitorBannerReducer,
  exhibitorFilesList: exhibitorFilesList,
  exhibitorFilesChanged: exhibitorFilesChanged,
  importExhibitorModal: importExhibitorModal,
  exhibitorWorkingDynamicForm: exhibitorWorkingDynamicForm,
  exhibitorModal: openExhibitorPopup,
  exhibitorsCount: exhibitorsCount,

  allSponsors: AllSponsorsReducers,
  sponsors: SponsorsReducers,
  sponsorCategories: SponsorCategoryReducers,
  editSponsorCategory: SponsorCategoryEditReducers,
  sponsorModal: openSponsorPopup,
  sponsor: loadEditSponsorData,
  sponsorImage: sponsorImageReducer,
  sponsorBanner: sponsorBannerReducer,
  sponsorFilesList: sponsorFilesList,
  sponsorFilesChanged: sponsorFilesChanged,
  importSponsorModal: importSponsorModal,
  sponsorWorkingDynamicForm: sponsorWorkingDynamicForm,
  sponsorsCount: sponsorsCount,

  webview: WebviewReducers,
  webviewedit: loadEditWebviewData,

  about: AboutReducers,
  aboutedit: loadEditAboutData,

  // location map
  locationMaps: locationMapReducers,
  showLocationMapModal: ShowLocationMapModal,
  initialLocationMap: InitialLocationMap,

  // Survey
  surveyList: surveyList,
  surveyResponseData: surveyResponseData,

  // Community
  communityList: communityList,
  addCommunityModal: addCommunityModal,
  editCommunity: editCommunity,
  requestedCommunityMemberList: requestedCommunityMemberList,

  // Advertisement
  advertisementsList: advertisementsList,
  advtAddModal: advtAddModal,
  advtBannerOptions: advtBannerOptions,
  advtEditData: advtEditData,

  totalAppModules: totalAppModules,
  actionAppModules: actionAppModules,
  contentDashboard: contentDashboard,
  editSeoCode: editSeoCode,
  eventData: eventReducers,
  interestModal: InterestModalReducer,
  interests: InterestsReducers,
  editInterest: EditInterestReducers,
  socials: SocialReducers,
  social: loadEditSocialData,
  socialModel: openSocialPopup,
  availableFeatures: ContentFeaturesReducer,
  selectedFeatures: selectedFeaturesReducer,
  contentDisplayItems: contentDisplayItems,
  appBottomMenu: appMenuReducer,
  appBtmMenuFixed: appBtmMenuFixed,
  fixedFeatures: fixedFeatures,
  news: fetchNews,
  newsImage: newsImageReducer,
  newsitem: fetchNewsItem,
  newsModal: openNewsPopup,
  fetchGallery: fetchGallery,
  imageReadyToAddGallery: imageReadyToAddGallery,
  thumbnailImage: thumbnailImage,
  galleryModal: galleryModal,
  scheduledates: fetchScheduleDates,
  updateScheduleDates: updateScheduleDates,
  dateProps: DatePropsReducer,
  sessionColors: SessionColorsReducer,
  signupStep: SignupStepReducer,
  user: UserReducer,
  signupUser: SignupRegisterReducer,
  signupSelectedFeature: SignupSelectedFeature,
  moveToLogin: ProceedToLogin,
  otp: SignupOTP,
  resetOtp: ResetSignupOTP,
  moveToDashboard: ProceedToDashboard,
  eventSettingsData: eventSettingsReducers,
  loggedinuserData: loggedinuserData,
  isOpenInstaLoader: isOpenInstaLoader,

  // Analytics -> Social Feed Inside ()
  socialFeedMenu: SocialFeedMenu,
  socialfeedSelectedItem: SocialfeedSelectedItem,
  socialfeedTousersEngagetablelist: SocialfeedTousersEngagetablelist,
  socialfeedPostypePaichartData: SocialfeedPostypePaichartData,
  socialfeedTotalPost: SocialfeedTotalPost,
  socialfeedTotalReaction: SocialfeedTotalReaction,
  socialfeedTotalComment: SocialfeedTotalComment,
  socialfeedTotalMedia: SocialfeedTotalMedia,
  socialfeedTotalPoll: SocialfeedTotalPoll,

  // Analytics -> Speakers
  speakerAnalyticMenu: SpeakerAnalyticMenu,
  speakerSelectedItem: SpeakerSelectedItem,
  speakerTopspkrTablelist: SpeakerTopspkrTablelist,
  speakerMostsearkeysTablelist: SpeakerMostsearkeysTablelist,
  speakerEngagementbarChart: SpeakerEngagementbarChart,
  speakerAnalyticTotalNoofspkr: SpeakerAnalyticTotalNoofspkr,
  speakerAnalyticTotalSpkrlistview: SpeakerAnalyticTotalSpkrlistview,
  speakerAnalyticTotalSpkrprofview: SpeakerAnalyticTotalSpkrprofview,
  speakerAnalyticTotalSpkrfavo: SpeakerAnalyticTotalSpkrfavo,

  // Analytics -> Session
  sessionAnalyticMenu: SessionAnalyticMenu,
  sessionSelectedItem: SessionSelectedItem,
  sessionTosessTablelist: SessionTosessTablelist,
  sessionQnqinsightsTablelist: SessionQnqinsightsTablelist,
  sessionMostsearkeysTablelist: SessionMostsearkeysTablelist,
  sessionAnalyticTotalSesslist: SessionAnalyticTotalSesslist,
  sessionAnalyticTotalSessfavo: SessionAnalyticTotalSessfavo,
  speakerTotalExhisearch: SpeakerTotalExhisearch,
  sessionAnalyticTotalSessListCnt: SessionAnalyticTotalSessListCnt,
  eventSessionList: EventSessionList,
  sessionScannedList: SessionScannedList,
  SessionRSVPUsersList: SessionRSVPUsersList,

  // Analytics -> Attendees Network
  attendeesNetworkMenu: AttendeesNetworkMenu,
  attendeesnetworkEngagementbarChart: AttendeesnetworkEngagementbarChart,
  attendeesnetworkPopuattenTablelist: AttendeesnetworkPopuattenTablelist,
  attendeesnetworkMstactvattenTablelist: AttendeesnetworkMstactvattenTablelist,
  attendeesnetworkMostsearkeysTablelist: AttendeesnetworkMostsearkeysTablelist,
  attendeesnetworkSelectedItem: AttendeesnetworkSelectedItem,
  attendeesnetworkTotalMsgsent: AttendeesnetworkTotalMsgsent,
  attendeesnetworkTotalScans: AttendeesnetworkTotalScans,
  attendeesnetworkTotalExhiprofview: AttendeesnetworkTotalExhiprofview,
  attendeesnetworkTotalSearch: AttendeesnetworkTotalSearch,
  attendeesNetworktotalfavo: AttendeesNetworktotalfavo,

  // Analytics -> Attendees Messaging Indide
  attendeesMessagingMenu: AttendeesMessagingMenu,
  attendeesmessagingSelectedItem: AttendeesmessagingSelectedItem,
  attendeesmessagingTotalSentmsg: AttendeesmessagingTotalSentmsg,
  attendeesmessagingTotalCommunication: AttendeesmessagingTotalCommunication,
  attendeesmessagingEngagementChart: AttendeesmessagingEngagementChart,
  attendeesmessagingTotalRecemsg: AttendeesmessagingTotalRecemsg,
  attendeesmessagingTotalMsgthread: AttendeesmessagingTotalMsgthread,

  // Analytics -> Sponsors Insights
  sponsorInsightMenu: SponsorInsightMenu,
  sponsorsinsightSelectedItem: SponsorsinsightSelectedItem,
  sponsorsinsightMostsearkeysTablelist: SponsorsinsightMostsearkeysTablelist,
  sponsorsinsightTopsponTablelist: SponsorsinsightTopsponTablelist,
  sponsorsinsightengagementbarChart: SponsorsinsightEngagementbarChart,
  sponsorsinsightTotalNoofspon: SponsorsinsightTotalNoofspon,
  sponsorsinsightTotalSponlistview: SponsorsinsightTotalSponlistview,
  sponsorsinsightTotalSponprofview: SponsorsinsightTotalSponprofview,
  sponsorsinsightTotalExhisearch: SponsorsinsightTotalExhisearch,
  sponsorsinsightTotalSponfavo: SponsorsinsightTotalSponfavo,

  // Analytics -> Exhibitors insights
  exhibitorInsightMenu: ExhibitorInsightMenu,
  exhibitorsinsightSelectedItem: ExhibitorsinsightSelectedItem,
  exhibitorsinsightMostsearkeysTablelist:
    ExhibitorsinsightMostsearkeysTablelist,
  exhibitorsinsightTopexhiTablelist: ExhibitorsinsightTopexhiTablelist,
  exhibitorsinsightToptagsexhiTablelist: ExhibitorsinsightToptagsexhiTablelist,
  exhibitorsinsightTopcountriesTablelist:
    ExhibitorsinsightTopcountriesexhiTablelist,
  exhibitorsinsightengagementbarChart: ExhibitorsinsightEngagementbarChart,
  exhibitorsinsightTotalNoofexhi: ExhibitorsinsightTotalNoofexhi,
  exhibitorsinsightTotalExhilistview: ExhibitorsinsightTotalExhilistview,
  exhibitorsinsightTotalExhiprofview: ExhibitorsinsightTotalExhiprofview,
  exhibitorsinsightTotalExhifavo: ExhibitorsinsightTotalExhifavo,
  exhibitorsinsightTotalExhisearch: ExhibitorsinsightTotalExhisearch,

  //Analytics -> Common Header
  analyticscommondatepropsreducer: AnalyticscommonDatePropsReducer,

  //AnalyticsAdvertisement -> Reducer
  advertisementviewAnalyticsdatalist: advertisementviewAnalyticsdatalist,
  advertisementclickAnalyticsdatalist: advertisementclickAnalyticsdatalist,
  advertisementAnalyticscounts: advertisementAnalyticscounts,

  // dashboard inside
  dashboardTotalAttendees: DashboardTotalAttendees,
  dashboardTotalAttenadoprate: DashboardTotalAttenadoprate,
  dashboardTotalAttedengaRate: DashboardTotalAttedengaRate,
  dashboardTotalInteractionRate: DashboardTotalInteractionRate,
  dashboardTotalMessagessCount: DashboardTotalMessagessCount,

  analyticsMenus: AnalyticsMenus,
  dashBoardMenu: DashBoardMenu,
  dashboardSelectedItem: DashboardSelectedItem,
  dashboardMostsearchKeysTablelist: DashboardMostsearchKeysTablelist,
  dashboardEngagementbarChart: DashboardEngagementbarChart,
  dashboardTotalUsers: DashboardTotalUsers,
  bulkUserUplodingLeft: bulkUserUplodingLeft,
  DashboardUserListWithoutAdmin: DashboardUserListWithoutAdmin,
  DashboardUserCategoryWise: DashboardUserCategoryWise,
  EventbriteKeys: EventbriteKeys,
  dashboardTotalSessions: DashboardTotalSessions,
  dashboardTotalDevices: DashboardTotalDevices,
  dashboardTotalNetworking: DashboardTotalNetworking,
  dashboardUserList: DashboardUserList,
  userOrderByDateCreated: UserOrderByDateCreated,
  userCategoryList: UserCategoryList,
  userEventDetails: userEventDetails,
  showDashboardUserModal: ShowDashboardUserModal,
  ShowDashboardUserCategoryModal: ShowDashboardUserCategoryModal,
  addEditUserCategory: addEditUserCategory,
  ShowDashboardUserExportModal: ShowDashboardUserExportModal,
  ShowEventPolicyTypeModal: ShowEventPolicyTypeModal,
  downloadUser: DownloadUser,
  userRestPasswordModal: userRestPasswordModal,
  showImportUserModal: ShowImportUserModal,
  showChooseUserModal: ShowChooseUserModal,
  dashboardUser: DashboardUser,
  noOfUsersHits: DashboardTotalNoOfUsersHits,
  totalNumberOfUsers: totalNumberOfUsers,
  appuserGroupManageModal,
  appUserListGroupManage,
  passcodeEmail: passcodeEmail,
  totalUsers: TotalUsers,
  eventDefautUserCheckoutForm: eventDefautUserCheckoutForm,
  appuserCounts: appuserCounts,
  usernotLoginCount: usernotLoginCount,
  viewAnalyticsData: viewAnalyticsData,
  userScanData: userScanData,
  totalUsernotLoginCount: totalUsernotLoginCount,

  dashboardNotificationList: DashboardNotificationList,
  dashboardScheduledNotificationList: DashboardScheduledNotificationList,
  DashboardNotificationModal: DashboardNotificationModal,
  DashboardNotificationViewModal: DashboardNotificationViewModal,

  addEditBooth: AddEditBoothReducer,
  imapResource: FetchLinkResourceReducer,
  activelyUpdatedBooth: UpdatedBoothReducer,
  deleteBoothLink: DeleteBoothLinkReducer,
  selectediMap: OpenIMapReducer,
  brandingData: brandingReducers,
  brandingColor: brandingColorReducers,
  themeColors: brandingThemeColorsReducers,
  brandingWebColor: brandingWebColorReducers,
  webthemeColors: brandingWebThemeColorsReducers,
  isUpdatedSideBottomAppMenu: isUpdatedSideBottomAppMenu,
  localImageIcon: brandingLocalIconImageReducer,
  localImageCover: brandingLocalCoverImageReducer,
  localWebImageIcon: brandingLocalWebIconImageReducer,
  localWebImageCover: brandingLocalWebCoverImageReducer,
  addMapName: AddMapNameReducer,
  openiMapModal: OpeniMapModalReducer,
  changeMapImage: ChangeMapReducer,
  interactiveMaps: FetchInteractiveMapsReducer,
  imapUploadProgress: UploadImapProgressReducer,
  imapImageUploadFailed: ImapImageUploadFailedReducer,
  imapImageUploadedData: ImapImageUploadedReducer,
  imapImageToUpload: ImapImageUploadReducer,
  speakerFiles: speakerFileList,
  sponsorFiles: sponsorFileList,
  exhibitorFiles: exhibitorFileList,
  boothToAdd: AddBoothDataReducer,
  interactivemaplocationsession: interactivemaplocationsession,
  boothToEdit: EditBoothDataReducer,
  showBoothEditor: ShowBoothEditorReducer,
  showAddBoothInfo: ShowAddBoothInfoReducer,
  toEditIconName: EditContentIconNameReducer,
  contentFileUploadProgress: UploadContentFileProgressReducer,
  contentFileUploaded: UploadContentFileUploadedReducer,
  contentFileUploadFailed: UploadContentFileFailedReducer,

  toEditAppBottomMenu: EditAppBottomMenuReducer,
  createdMenu: createdMenu,
  splashScreenData: splashScreenData,

  signupChangeEmail: SignupChangeEmail,
  fromLogin: FromLogin,
  showCheckoutModal: ShowCheckoutModalReducer,
  contactUsModal: ContactUsModalReducer,
  updateCheckoutDetails: UpdateCheckoutDetailsReducer,
  globalCountData: GlobalCountReducer,

  featuresModal: ShowFeaturesModalReducer,
  contentAddRemoveModal: contentAddRemoveModal,
  membershipModal: ShowMembershipModalReducer,
  sessionWeekdays: sessionWeekdays,
  sessionDefaultTrack: sessionDefaultTrack,
  activeDateAllSessions: activeDateAllSessions,
  allAdditionalSessions: allAdditionalSessions,

  processing: ProcessingReducer,
  templates: TemplatesReducer,
  eventSelectedTemplate: eventTemplatesReducer,
  websiteContact: websiteContactReducer,
  templatesMenus: TemplatesMenus,
  eventcode: EventcodeReducer,

  ticketMenus: TicketReducers,
  TicketList: TicketList,
  allTicketList: allTicketList,
  siglrCategoryTicketList: siglrCategoryTicketList,
  allCouponList: allCouponList,
  CouponList: CouponList,
  EditCoupon: EditCoupon,
  EditTicket: EditTicket,
  SettingData: SettingData,
  OrderList: OrderList,
  StripeAccountData: StripeAccountData,
  ticketCurrency: TicketCurrency,
  showTicketModal: showTicketModal,
  showTicketUrlModal: showTicketUrlModal,
  showTicketOrderUrlModal: showTicketOrderUrlModal,
  showOrderTicketModal: showOrderTicketModal,
  showDefaultTermsModal: showDefaultTermsModal,
  ticketDashboard: ticketDashboard,
  formBuilderModal: formBuilderModal,
  formList: formList,
  formName: formName,
  formBuildeList: formBuildeList,
  totalFormBuildeList: totalFormBuildeList,
  formChanged: formChanged,
  stripeCurrencyDetailsList: stripeCurrencyDetailsList,
  WizardStep: WizardStep,
  ShowSalesReportExportModal: ShowSalesReportExportModal,
  refundModalShow: refundModalShow,
  paymentGatewayModal: paymentGatewayModal,
  clientCardInfoModal: clientCardInfoModal,
  ticketSendList: ticketSendList,
  ticketSesionModal: ticketSesionModal,
  ticketSortbyModal: ticketSortbyModal,

  // Branding

  brandingMenus: BrandingMenus,

  // Polls
  pollMenus: PollMenus,
  pollList: pollList,
  selectPollListType: selectPollListType,
  ShowPollExportModal: ShowPollExportModal,
  broadcastLivePolls: broadcastLivePolls,

  // Live Q&A
  scheduleSessions: scheduleSessions,
  selectedSession: selectedSession,
  livePublishedQAList: livePublishedQAList,
  liveUnpublishedQAList: liveUnpublishedQAList,
  selectPublishedType: selectPublishedType,
  liveQAReplies: liveQAReplies,
  broadcastLiveQA: broadcastLiveQA,
  allPublishesSessionwiseLiveQA: allPublishesSessionwiseLiveQA,
  ShowLiveQAExportModal: ShowLiveQAExportModal,

  // Rating
  singleSessionRatings: singleSessionRatings,
  allSessionRatings: allSessionRatings,
  allSessionId: allSessionId,
  singleSessionCheckouForm: singleSessionCheckouForm,

  allevents: AllEventsReducer,
  showEventChooserModal: OpenEventChooserReducer,
  initiateCreateEvent: InitiateCreateEventReducer,
  showEventCloneModal: OpenEventCloneReducer,
  statusCloneEvent: CloneEventStatusReducer,
  deviceSize: deviceSize,

  // Billingpayment
  clientinvoiceforpayment: clientinvoiceforpayment,
  clientuserlimitandexpiry: clientuserlimitandexpiry,

  settingMenus: SettingMenus,
  templateData: templateReducers,
  appstoreDetails: appstoreDetails,
  appstoreLocalLogo: appstoreLocalLogoReducer,
  appstoreOtherImages: appstoreOtherImagesReducer,
  emailLogData: emailLogReducers,
  emailLogContentReducers: emailLogContentReducers,
  activeUsrsDetails: activeUsrsDetails, // Billing Details Active User Tbl List
  languageAddModalReducer: languageAddModalReducer,
  eventLanguages: eventLanguages,
  languageCsvImportModalReducer: languageCsvImportModalReducer,
  integrationModalReducer: integrationModalReducer,
  allEmailLog: allEmailLog,

  // account Setting
  accountsettingMenus: AccountSettingMenus,
  clientdataforbilling: clientdataforbilling,
  alleventclientData: alleventclientData,
  client_historydata: client_historydata,
  total_accountusageCount: total_accountusageCount,
  usagehistoryDatalist: usagehistoryDatalist,
  reportPlatforms: reportPlatforms,
  adminissueListopen: adminissueListopen,
  adminissueListclose: adminissueListclose,
  alleventsunderClient: alleventsunderClient,
  eventBasedData: eventBasedData,
  eventsunderClient: eventsunderClient,
  singleReportdata: singleReportdata,
  allcountryList: allcountryList,

  // Proposal
  proposalMenus: ProposalReducer,
  ProposalStep: ProposalStep,
  checkProposalForm: checkProposalForm,
  proposalReviewerStatus: proposalReviewerStatus,
  proposalReviewCriteriaStatus: proposalReviewCriteriaStatus,
  appUserreviewerList: appUserreviewerList,
  proposalFormList: proposalFormList,
  reviewerList: reviewerList,
  responseList: responseList,
  proposalList: proposalList,
  showProposalUrlModal: showProposalUrlModal,
  editProposalModal: editProposalModal,
  addReviewerModal: addReviewerModal,
  showChangeReviewer: showChangeReviewer,
  showProposalResponse: showProposalResponse,
  proposalRanking: proposalRanking,
  showProposalTicketModal: showProposalTicketModal,
  showManageProposalModal: showManageProposalModal,
  updateProposal: updateProposal,
  showChangePasswordReviewer: showChangePasswordReviewer,
  proposalConfirmModal: proposalConfirmModal,
  proposalAttendeeList: proposalAttendeeList,
  unreviewedproposalList: unreviewedproposalList,
  reviewedproposalList: reviewedproposalList,
  shortlistedproposalList: shortlistedproposalList,
  rejectedproposalList: rejectedproposalList,
  showproposalLoader: showproposalLoader,
  ratingStore: ratingStore,
  allresponseProposal: allresponseProposal,
  updatedProposalLoader: updatedProposalLoader,
  filterbyProposal: filterbyProposal,
  sortbyFilter: sortbyFilter,

  // Templates or Website
  TemplatesWizardStep: TemplatesWizardStep,
  TemplatesWizardData: TemplatesWizardData,
  connectDomainModal: connectDomainModal,
  connectDomainData: connectDomainData,
  optionStateInstallURL: optionStateInstallURL,
  templateThemeData: templateThemeData,
  optionStatePublish: optionStatePublish,
  confirmModal: confirmModal,
  selectedPlan: selectedPlan,
  optionStateTheme: optionStateTheme,
  websiteModule: websiteModule,
  siteDetails: siteDetails,
  optionStateDomains: optionStateDomains,
  optionStateUpgrade: optionStateUpgrade,
  templateModulepath: templateModulepath,
  redeploy: redeploy,
  initialCheckAtTheme: initialCheckAtTheme,
  templateImagepath: templateImagepath,
  websitePages: websitePages,
  titleUrl: titleUrl,
  headerFooter: headerFooter,

  // Courses
  courseMenus: CourseMenus,
  courseWizardStep: courseWizardStep,
  courseWizardAllSteps: courseWizardAllSteps,
  allCourseList: allCourseList,
  allCourseName: allCourseName,
  allUnpublishedCourseList: allUnpublishedCourseList,
  courseList: courseList,
  quizList: quizList,
  courseLessonModal: courseLessonModal,
  lessonTextAttachment: lessonTextAttachment,
  lessonDocumentAttachment: lessonDocumentAttachment,
  lessonVideoAttachment: lessonVideoAttachment,
  lessonAudioAttachment: lessonAudioAttachment,
  lessonLinkAttachment: lessonLinkAttachment,
  currentChapterOpen: currentChapterOpen,
  tempChapterRanking: tempChapterRanking,
  tempLessonRanking: tempLessonRanking,
  editLessonData: editLessonData,
  chapterModal: chapterModal,
  courseModal: courseModal,

  /**** Gamification [reducers] Variable maker  ****/
  gamificationMenus: GamificationMenus,

  managechallengesMenu: ManagechallengesMenu,
  managechallengesSelectedTab: ManagechallengesSelectedTab,
  manageChallengesList: ManageChallengesList,
  challenge: LoadEditchallengesData,
  challengeModel: OpenChallengesPopup,
  maxDisplayorder: GetMaxDisplayorder,
  staticTemplteHtml: getStaticTemplteHtml,
  leaderboardUserList: LeaderboardUserList,
  extraPointsModalReducer,
  allGameChallengesReducer,
  gamificationLogList,
  rewardData: RewardData,

  /**** Content Event Guide ****/
  categoryList: CategoryList,
  eventGuideList: EventGuideList,
  eventguideModel: OpenEventGuideModal,
  eventguide: LoadEditeventguidesData,
  maxDisplayordereventguide: GetMaxDisplayorderEventGuide,
  eventguidefilesList: eventguidefilesList, //10 files data
  eventguidefilesChanged: eventguidefilesChanged, //File bool

  // Sendpush in survey Timming
  sendPushTimes: sendPushTimes,
  checkinType: checkinType,

  /*** Support Chat ***/
  chatThread: Chatthread,
  chatthreadDetails: ChatthreadDetails,
  userDetailsWithEmail: userDetailsWithEmail,
  unreadcount: unreadcount,

  /*** Badge Design ***/
  isBadgeDesignModalOpen: isBadgeDesignModalOpen,
  isGenerateBadgeModalOpen: isGenerateBadgeModalOpen,
  dashboardAllBadgeList: dashboardAllBadgeList,
  dashboardBadgeList: dashboardBadgeList,
  templateJson: templateJson,
  selectedElement: selectedElement,
  dataInEditMode: dataInEditMode,
  DashboardBadgeAllUserList: DashboardBadgeAllUserList,
  dashboardBadgeUserList: DashboardBadgeUserList,
  isPrintPreviewModalOpen,
  userDetails, // User deatils [Designation , company name etc]
  imageElementModal,
});

const rootReducer = (state, action) => {
  if (action.type === "ACTION_LOGOUT") {
    return appReducer(undefined, action);
  } else if (action.type === "RESET_REDUX_STORE_ADMIN_NO_EVENT") {
    // this is used to clear all the redux state if admin has no event or switch his event.
    var newState = {
      isLoggedIn: LoginReducer,
      session: TokensReducer,
      user: UserReducer,
      showEventChooserModal: OpenEventChooserReducer,
    };

    return appReducer(newState, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
